import { render, staticRenderFns } from "./GradeDeEntregaForm.vue?vue&type=template&id=960ad8ee"
import script from "./GradeDeEntregaForm.vue?vue&type=script&lang=js"
export * from "./GradeDeEntregaForm.vue?vue&type=script&lang=js"
import style0 from "./GradeDeEntregaForm.vue?vue&type=style&index=0&id=960ad8ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports